import { render } from "./RequiredAttachment.vue?vue&type=template&id=6e1b5a7e"
import script from "./RequiredAttachment.vue?vue&type=script&lang=js"
export * from "./RequiredAttachment.vue?vue&type=script&lang=js"

import "./RequiredAttachment.vue?vue&type=style&index=0&id=6e1b5a7e&lang=css"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__